/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import get from 'lodash/get';
import { Form, Input, Select, Checkbox, Icon } from 'antd';

import './PrefixForm.style.less';
import {
  PREFERRED_CHANNELS,
  BACKUP_CHANNELS,
  BNI_CODE,
  CIMB_CODE,
} from '../../constant/AllBillerDefaultVar';
const { Option } = Select;

export default class PrefixForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      preferredChannel: get(this.props, 'row.preferred_channel', ''),
      backupChannel: get(this.props, 'row.backup_channel', ''),
      vaPrefix: get(this.props, 'row.va_prefix', ''),
    };
  }

  getBankCode = () => {
    const {
      form: { getFieldValue },
      listBank,
    } = this.props;

    const bankId = getFieldValue('bank_id');
    let selectedBank = '';

    if (bankId) {
      const selectedBankIndex = listBank.findIndex(
        item => item.bank_id === getFieldValue('bank_id'),
      );

      selectedBank = listBank[selectedBankIndex].bank_code;
    }
    return selectedBank;
  };

  componentDidMount() {
    const selectedBank = this.getBankCode();
    const selectedPreferredChannel = this.state.preferredChannel;

    if (
      (selectedBank !== BNI_CODE && selectedPreferredChannel === 'DCBNI') ||
      (selectedBank !== CIMB_CODE && selectedPreferredChannel === 'DCCIMB')
    ) {
      this.resetInputField();
    }
  }

  onActionValidate = (err, values) => {
    if (!err) {
      const {
        form: { getFieldValue },
      } = this.props;

      const listBank = get(this.props, 'listBank', []);
      const selectedBankId = getFieldValue('bank_id');
      const selectedBank = listBank.find(
        bank => bank.bank_id === selectedBankId,
      );
      const selectedBankCode = get(selectedBank, 'bank_code', '');
      values.backup_channel = getFieldValue('backup_channel') || '';
      values.va_prefix = getFieldValue('va_prefix') || '';

      if (
        this.state.preferredChannel === 'GENESIS' &&
        !getFieldValue('biller_code')
      ) {
        this.props.form.setFields({
          biller_code: {
            value: getFieldValue('biller_code'),
            errors: [new Error('Require Biller Code!')],
          },
        });
      }

      const submittedValues = {
        bank_code: selectedBankCode,
        ...values,
      };

      this.props.submitPrefix(submittedValues);
    }
  };

  submitPrefixForm = e => {
    e.preventDefault();
    this.props.form.validateFields(this.onActionValidate);
  };

  onReset = e => {
    e.preventDefault();
    this.props.form.validateFields(this.onBillerDelete);
  };

  onBillerDelete = (err, values) => {
    const {
      form: { getFieldValue },
    } = this.props;

    const listBank = get(this.props, 'listBank', []);
    const selectedBankId = getFieldValue('bank_id');
    const selectedBank = listBank.find(bank => bank.bank_id === selectedBankId);
    const selectedBankCode = get(selectedBank, 'bank_code', '');
    const submittedValues = {
      bank_code: selectedBankCode,
      ...values,
    };

    this.props.billerDelete(submittedValues);
  };

  selectionFilter = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  optionData = listSelection =>
    listSelection.map(item => (
      <Option key={item.bank_id} value={item.bank_id}>
        {item.bank_name}
      </Option>
    ));

  resetInputField = () => {
    this.resetPreferredChannel();
    this.resetBackupChannel();
    this.resetVaPrefix();
  };

  resetPreferredChannel = () => {
    this.props.form.setFieldsValue({
      preferred_channel: undefined,
    });
    this.setState({ preferredChannel: undefined });
  };

  resetBackupChannel = () => {
    this.props.form.setFieldsValue({
      backup_channel: undefined,
    });
    this.setState({ backupChannel: undefined });
  };

  resetVaPrefix = () => {
    this.props.form.setFieldsValue({
      va_prefix: undefined,
    });
    this.setState({ vaPrefix: undefined });
  };

  resetBillerCode = () => {
    this.props.form.setFieldsValue({
      biller_code: undefined,
    });
  };

  _renderBankList = () => {
    const listSelection = _.get(this.props, 'listBank', []).map(item => ({
      bank_id: item.bank_id,
      bank_name: `${item.bank_code} - ${item.name}`,
    }));
    const optionRender = this.optionData(listSelection);

    return (
      <Select
        showSearch
        placeholder="Search by bank code or bank name"
        optionFilterProp="children"
        filterOption={this.selectionFilter}
        size="large"
        suffixIcon={<Icon type="search" />}
        onChange={this.resetInputField}
      >
        {optionRender}
      </Select>
    );
  };

  _renderFormBank = () => {
    const {
      form: { getFieldDecorator },
      row,
    } = this.props;

    const listBank = get(this.props, 'listBank', []);
    const initialBankCode = get(row, 'bank_code', '');
    const initialBank = listBank.find(
      bank => bank.bank_code === initialBankCode,
    );
    const initialBankId = get(initialBank, 'bank_id', '');

    const fieldDecorator = {
      rules: [
        {
          required: true,
          message: 'Require Bank Name!',
        },
      ],
      ...(initialBankId !== '' && { initialValue: initialBankId }),
    };

    return (
      <Form.Item label="Bank Name" required colon={false}>
        {getFieldDecorator('bank_id', fieldDecorator)(this._renderBankList())}
      </Form.Item>
    );
  };

  _renderFormVaPrefix = () => {
    const { nonMandatoryVaPrefixBankList } = this.props;

    const selectedBank =
      this.getBankCode() || get(this.props, 'row.bank_code', '');
    const isVaPrefixNotMandatory = nonMandatoryVaPrefixBankList.includes(
      selectedBank,
    );

    return (
      <Form.Item
        label="VA Prefix"
        required={!isVaPrefixNotMandatory}
        colon={false}
      >
        {this.props.form.getFieldDecorator('va_prefix', {
          initialValue: this.state.vaPrefix,
          rules: [
            {
              min: 1,
              message: 'Minimum 1 Digit Number',
            },
            {
              max: 10,
              message: 'Maximum 10 Digit Number',
            },
            {
              required: !isVaPrefixNotMandatory,
              message: 'Require Va Prefix Number!',
            },
          ],
        })(<Input placeholder="Input VA Prefix" size="large" type="number" />)}
      </Form.Item>
    );
  };

  _renderFormBankAccount = () => {
    const initialValue = get(this.props, 'row.bank_account', '');

    return (
      <Form.Item label="Bank Account" required colon={false}>
        {this.props.form.getFieldDecorator('bank_account', {
          initialValue,
          rules: [
            {
              min: 10,
              message: 'Minimum 10 Digit Number',
            },
            {
              required: true,
              message: 'Require Bank Account Number!',
            },
          ],
        })(
          <Input
            placeholder="Input Bank Account Number"
            type="number"
            size="large"
          />,
        )}
      </Form.Item>
    );
  };

  onChangePreferredChannel = selectedPreferredChannel => {
    this.resetBackupChannel();
    this.resetBillerCode();
    this.setState({ preferredChannel: selectedPreferredChannel });
  };

  _renderListPreferredChannel = () => {
    const {
      form: { getFieldValue },
      channelList,
    } = this.props;

    const channelData =
      channelList.length > 0 ? channelList : PREFERRED_CHANNELS;
    const bankId = getFieldValue('bank_id');
    const selectedBank = this.getBankCode();

    const preferredChannels = channelData.map(backupChannel => {
      const isDisabled =
        (backupChannel === 'DCCIMB' && selectedBank !== CIMB_CODE) ||
        (backupChannel === 'DCBNI' && selectedBank !== BNI_CODE);
      return (
        <Option key={backupChannel} value={backupChannel} disabled={isDisabled}>
          {backupChannel}
        </Option>
      );
    });

    return (
      <Select
        placeholder="Select preferred channel"
        optionFilterProp="children"
        filterOption={this.selectionFilter}
        size="large"
        disabled={bankId === undefined}
        onChange={this.onChangePreferredChannel}
      >
        {preferredChannels}
      </Select>
    );
  };

  _renderFormPreferredChannel = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;

    const initialPreferredChannel = get(
      this.props,
      'row.preferred_channel',
      '',
    );

    const fieldDecorator = {
      rules: [
        {
          required: true,
          message: 'Require Preferred Channel!',
        },
      ],
      ...(initialPreferredChannel !== '' && {
        initialValue: initialPreferredChannel,
      }),
    };

    return (
      <>
        <Form.Item label="Preferred Channel" required colon={false}>
          {getFieldDecorator('preferred_channel', fieldDecorator)(
            this._renderListPreferredChannel(),
          )}
        </Form.Item>
      </>
    );
  };

  _renderFormBillerCode = isGenesis => {
    const {
      form: { getFieldDecorator },
    } = this.props;

    const initialBillerCode = get(this.props, 'row.biller_code', '');
    const fieldDecorator = {
      rules: [
        {
          required: isGenesis,
          message: 'Require Biller Code!',
        },
      ],
      ...(initialBillerCode !== '' && { initialValue: initialBillerCode }),
    };

    return (
      <Form.Item label="Biller Code" required={isGenesis} colon={false}>
        {getFieldDecorator('biller_code', fieldDecorator)(
          <Input placeholder="Input Biller Code" size="large" type="number" />,
        )}
      </Form.Item>
    );
  };

  onChangeBackupChannel = selectedBackupChannel => {
    this.resetBillerCode();
    this.setState({ backupChannel: selectedBackupChannel });
  };

  _renderListBackupChannel = () => {
    const {
      form: { getFieldValue },
      channelList,
    } = this.props;

    const channelData = channelList.length > 0 ? channelList : BACKUP_CHANNELS;
    const bankId = getFieldValue('bank_id');
    const preferredChannel = getFieldValue('preferred_channel');
    const selectedBank = this.getBankCode();

    const backupChannels = channelData.map(backupChannel => {
      const isDisabled =
        preferredChannel === backupChannel ||
        (backupChannel === 'DCCIMB' && selectedBank !== CIMB_CODE) ||
        (backupChannel === 'DCBNI' && selectedBank !== BNI_CODE);

      return (
        <Option key={backupChannel} value={backupChannel} disabled={isDisabled}>
          {backupChannel}
        </Option>
      );
    });

    return (
      <Select
        allowClear
        placeholder="Select backup channel"
        optionFilterProp="children"
        filterOption={this.selectionFilter}
        size="large"
        disabled={bankId === undefined}
        onChange={this.onChangeBackupChannel}
      >
        {backupChannels}
      </Select>
    );
  };

  _renderFormBackupChannel = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;

    const initialBackupChannel = get(this.props, 'row.backup_channel', '');
    const fieldDecorator = {
      ...(initialBackupChannel !== '' && {
        initialValue: initialBackupChannel,
      }),
    };

    return (
      <>
        <Form.Item label="Backup Channel" colon={false}>
          {getFieldDecorator('backup_channel', fieldDecorator)(
            this._renderListBackupChannel(),
          )}
        </Form.Item>
      </>
    );
  };

  _renderFormCheckboxDefaultPrefix = () => {
    const {
      form: { getFieldDecorator },
      isListBillerEmpty,
      billerType,
    } = this.props;

    // To retain data when user filled the form
    // and cancel confirm to set as default prefix
    const isDefaultPrefix = get(this.props, 'row.priority', '-1') === '1';

    const isFilledDefaultPrefix = get(
      this.props,
      'row.is_default_prefix',
      false,
    );

    return (
      <Form.Item>
        {getFieldDecorator('is_default_prefix', {
          valuePropName: 'checked',
          initialValue:
            isDefaultPrefix || isListBillerEmpty || isFilledDefaultPrefix,
        })(
          <Checkbox
            className="display-block"
            disabled={isDefaultPrefix || isListBillerEmpty}
          >
            Set as Default {billerType === 1 ? 'Bank Account ' : 'Prefix'}
          </Checkbox>,
        )}
      </Form.Item>
    );
  };

  render() {
    const { billerType } = this.props;
    const { preferredChannel, backupChannel } = this.state;

    const isDefaultPrefix = get(this.props, 'row.priority', '-1') === '1';

    const isPreferredChannelGenesis = preferredChannel === 'GENESIS';
    const isBackupChannelGenesis = backupChannel === 'GENESIS';

    const isBillerTypeBankAccount = billerType === 1;

    const renderedFormNumberInput = isBillerTypeBankAccount
      ? this._renderFormBankAccount()
      : this._renderFormVaPrefix();

    return (
      <Form
        onSubmit={this.submitPrefixForm}
        onReset={this.onReset}
        className="prefix-form"
        id="prefixForm"
      >
        {this._renderFormBank()}
        {renderedFormNumberInput}
        {this._renderFormPreferredChannel()}
        <div className="form-biller-code margin-bottom-20">
          {this._renderFormBillerCode(isPreferredChannelGenesis)}
        </div>
        {this._renderFormBackupChannel()}
        <div className="form-biller-code">
          {isBackupChannelGenesis &&
            this._renderFormBillerCode(isBackupChannelGenesis)}
        </div>
        {isBackupChannelGenesis && (
          <div className="span-biller-code">
            Biller Code only available on Genesis as Backup Channel
          </div>
        )}
        <div className="checkbox-default-prefix">
          {this._renderFormCheckboxDefaultPrefix()}
        </div>
        {isDefaultPrefix && (
          <span className="span-checkbox">
            This value cannot be changed, assign other{' '}
            {isBillerTypeBankAccount
              ? 'bank account as default bank account'
              : 'prefix as default prefix'}{' '}
            first
          </span>
        )}
      </Form>
    );
  }
}

PrefixForm.propTypes = {
  form: PropTypes.object,
  submitPrefix: PropTypes.func,
  billerType: PropTypes.number,
  row: PropTypes.object,
  isListBillerEmpty: PropTypes.bool,
  billerDelete: PropTypes.func,
  listBank: PropTypes.array,
  channelList: PropTypes.array,
  nonMandatoryVaPrefixBankList: PropTypes.array,
};
